export const P00058SpeedDefaultValue = (vitessMaxRpm: number = 1000) => {
  const defaultValues: any = {};

  for (let i = 0; i <= 100; i = i + 5) {
    let rpm = Math.round((vitessMaxRpm * (i / 100)) / 100) * 100;
    rpm = rpm >= vitessMaxRpm ? vitessMaxRpm : rpm;
    defaultValues[i + '%'] = rpm;
  }

  return defaultValues;
};

export const P00058SpeedEnum = (
  t: any,
  consignUnit: number = 0,
  vitessMaxRpm: number = 1000,
  minPurcent = 35,
  maxPurcent = 100,
  stepPurcent = 5,
  minRpm = 1000,
  maxRpm = 10000,
  stepRpm = 100,
) => {
  let res = [];

  if (maxRpm === 0) {
    maxRpm = 3250;
  }

  if (consignUnit === 0) {
    if (minRpm / maxRpm < 0.3) {
      minPurcent = 20;
    } else {
      minPurcent = 35;
    }

    for (let i = minPurcent; i <= maxPurcent; i = i + stepPurcent) {
      let rpm = Math.round((vitessMaxRpm * (i / 100)) / 100) * 100;
      rpm = rpm >= vitessMaxRpm ? vitessMaxRpm : rpm;
      res.push({ ref: rpm, label: i + ' %' });
    }
  } else if (consignUnit === 1) {
    maxRpm = Math.round(vitessMaxRpm / 100) * 100;

    for (let i = minRpm; i <= maxRpm; i = i + stepRpm) {
      let r = i >= vitessMaxRpm ? vitessMaxRpm : i;
      res.push({
        ref: r,
        label: i + ' ' + t.instant('P00058.installation.rpm'),
      });
    }
  }

  return res;
};
